import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dari_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Extract a human-readable error message from any axios/FastAPI error.
 * Handles FastAPI 422 pydantic detail (list of {loc, msg, type, ...}) safely
 * so React never receives an object as a child.
 */
export const errMsg = (e, fallback = "Erreur") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d
      .map((x) => {
        if (typeof x === "string") return x;
        const field = Array.isArray(x?.loc) ? x.loc[x.loc.length - 1] : "";
        const msg = x?.msg || "Champ invalide";
        return field ? `${field}: ${msg}` : msg;
      })
      .join(" · ");
  }
  if (d && typeof d === "object") return d.msg || JSON.stringify(d);
  if (typeof e?.message === "string") return e.message;
  return fallback;
};

/** Pick title/description in the active language, fall back to the stored original. */
export const localized = (item, field, lang) => {
  const map = item?.[`i18n_${field}`];
  if (map && typeof map === "object" && map[lang]) return map[lang];
  return item?.[field] || "";
};

export { API };
